<template>
  <div class="zch-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ZchContent'
}
</script>

<style lang="scss" scoped>
  .zch-content {
    flex: 1;
  }
</style>